<template>
  <b-card header="Assign Lock to Lock Group">
    <b-form id="lockgroupmapper-form">
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Select Lock</b-input-group-text></b-input-group-prepend>
            <select-lock :locationId=locationId></select-lock>
          <b-input-group-append><b-input-group-text><i class="fa fa-key"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Select Lock Group</b-input-group-text></b-input-group-prepend>
            <select-lock-group :locationId=locationId></select-lock-group>
          <b-input-group-append><b-input-group-text><i class="fa fa-group"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>
      <div class="form-group form-actions">
        <b-button @click="submitData" type="submit" size="sm" variant="primary">Assign</b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
let qs = require('qs')
const constants = require('./shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/lockGroupMappers/add'

function postdata (url, data) {
  const thisForm = document.getElementById('lockgroupmapper-form')
  const selectedLockInput = thisForm.querySelector('select[name=listLock]')
  const selectedLockGroupInput = thisForm.querySelector('select[name=listLockGroup]')
  data.lockId = selectedLockInput.value
  data.lockGroupId = selectedLockGroupInput.value
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  })
    .then(res => res.json())
}

export default {
  name: 'lock-to-lock-group-mapper-form',
  data () {
    return {
      myLock: '',
      mylocks: {},
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        lockId: null,
        lockGroupId: null
      }
    }
  },
  props: ['locationName', 'locationId', 'locationDescription'],
  methods: {
    submitData (evt) {
      evt.preventDefault()
      postdata(API, this.formData)
        .then(data => {
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
      location.reload()
    },
    onReset (evt) {
      evt.preventDefault()
      this.formData.lockId = ''
      this.formData.lockGroupId = ''
      this.show = false
      this.$nextTick(() => { this.show = true })
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          alert('From Submitted!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/LockToLockGroupMapperForm.vue